import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getAnalytics, Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyD7iLyKHkYQuknX6c6pjLMIDR2gpI27E_E',
  authDomain: 'marsi-connect.firebaseapp.com',
  projectId: 'marsi-connect',
  storageBucket: 'marsi-connect.firebasestorage.app',
  messagingSenderId: '901375720821',
  appId: '1:901375720821:web:b188a1e2739fa3f8e0673c',
  measurementId: 'G-H9VC89VZSH',
};

const app: FirebaseApp = initializeApp(firebaseConfig);

const auth: Auth = getAuth(app);
const db: Firestore = getFirestore(app);
const storage: FirebaseStorage = getStorage(app);
const analytics: Analytics = getAnalytics(app);

export { app, auth, db, storage, analytics };
